/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
} from "@solana/kit";

export interface OpenPositionBumps {
  positionBump: number;
}

export type OpenPositionBumpsArgs = OpenPositionBumps;

export function getOpenPositionBumpsEncoder(): FixedSizeEncoder<OpenPositionBumpsArgs> {
  return getStructEncoder([["positionBump", getU8Encoder()]]);
}

export function getOpenPositionBumpsDecoder(): FixedSizeDecoder<OpenPositionBumps> {
  return getStructDecoder([["positionBump", getU8Decoder()]]);
}

export function getOpenPositionBumpsCodec(): FixedSizeCodec<
  OpenPositionBumpsArgs,
  OpenPositionBumps
> {
  return combineCodec(
    getOpenPositionBumpsEncoder(),
    getOpenPositionBumpsDecoder(),
  );
}
